"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var ramda_1 = require("ramda");
var constants_1 = require("./constants");
var api_1 = require("../../utils/api");
var reducers = {
    isNavigationReady: api_1.createCustomModuleReducer((_a = {},
        _a[constants_1.SET_NAVIGATION_READY] = function (state, action) { return action.payload; },
        _a), false),
    epgDaysLoaded: api_1.createCustomModuleReducer((_b = {},
        _b[constants_1.SET_EPG_DAY_LOADED] = function (state, action) {
            var _a;
            return __assign(__assign({}, state), (_a = {}, _a[action.payload.dayCode] = action.payload, _a));
        },
        _b[constants_1.REMOVE_EPG_DAY_LOADED] = function (state, action) {
            return ramda_1.omit([action.payload.dayCode], state);
        },
        _b), {}),
};
exports.default = redux_1.combineReducers(reducers);
//# sourceMappingURL=reducer.js.map